import { BaSeParagraph, BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';
import { banner_empretec } from '../../../../utils/images';

export const handleQuerySmall = (style) => {
  return `
  ${BaSeTheme.breakpoints.tablet.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const handleQueryBig = (style) => {
  return `
    ${BaSeTheme.breakpoints.desktop.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.desktopLarge.mediaQueryCss(style)};
  `;
};

export const BackgroundCandidate = styled.div`
  width: 100vw;
  height: max(945px, 100vh);
  max-width: ${BaSeTheme.breakpoints.desktop.maxWidth}px;

  ${({ empretecCandidateActor, empretecGraphics }) => css`
    background: url(${empretecCandidateActor}) no-repeat left -20px top 0px,
      url(${empretecGraphics}) no-repeat left 20px top -40px,
      url(${banner_empretec}) no-repeat left 600px top 870px;
  `}

  ${handleQuerySmall(css`
    display: flex;
    justify-content: center;
    align-items: start;
    background: url(${banner_empretec}) no-repeat right 30px bottom 30px;
  `)}
`;

export const CandidateInterviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 475px;
  padding-top: 175px;
  padding-left: 780px;
  margin: 0 20px 20px 20px;

  ${handleQuerySmall(css`
    display: flex;
    align-items: center;
    margin-top: 24px;
    padding-top: 0px;
    padding-left: 0px;
  `)}
`;

export const ButtonStartInterview = styled.div`
  display: flex;
  justify-content: center;

  ${handleQueryBig(`
    justify-content: start;
  `)}
  ${({ id }) =>
    id === 1 &&
    css`
      .BaSe--button {
        border: 1px solid #bf303c;
      }
    `}

    border: none;
`;

export const ImageEmpretecText = styled.div`
  ${({ imgTextHome }) => css`
    background-image: url(${imgTextHome});
  `}
  background-repeat: no-repeat;
  width: 500px;
  height: 233px;

  ${handleQuerySmall(css`
    width: 350px;
  `)}
`;

export const ContentWithInterviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 35px;
  gap: 30px;
  max-width: 475px;
`;

export const TextWithInterviewWrapper = styled(BaSeParagraph)`
  display: flex;
  flex-direction: column;
  gap: 25px;
  color: ${BaSeTheme.colors.institucionais.cinzaSebrae60};
`;

export const ContentWithOutInterviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  gap: 20px;

  ${handleQuerySmall(css`
    align-items: center;
  `)}
`;
